var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-project-audit",
    },
    [
      _c("div", { staticClass: "yxtbiz-project-audit__title" }, [
        _vm._v(
          _vm._s(_vm.$t("pc_biz_pulish_project_audit" /* 项目发布审核 */))
        ),
      ]),
      _c(
        "yxt-row",
        { staticClass: "yxtbiz-project-audit__row", attrs: { gutter: 32 } },
        [
          _c(
            "yxt-col",
            { staticClass: "yxtbiz-project-audit__col", attrs: { span: 12 } },
            [
              _c(
                "div",
                { staticClass: "color-gray-7 yxtbiz-project-audit__label" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("pc_biz_ojt_lbl_projectname" /* 项目名称 */) +
                        _vm.$t("pc_biz_enroll_lbl_colon" /* : */)
                    )
                  ),
                ]
              ),
              _c(
                "yxt-tooltip",
                {
                  attrs: {
                    content: _vm.project.projectName,
                    placement: "top",
                    "open-filter": "",
                  },
                },
                [
                  _c("div", { staticClass: "color-gray-10 ellipsis nowrap" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.project.projectName) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "yxt-col",
            { staticClass: "yxtbiz-project-audit__col", attrs: { span: 12 } },
            [
              _c(
                "div",
                { staticClass: "color-gray-7 yxtbiz-project-audit__label" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "pc_o2o_lbl_relative_plan_name" /* 关联培训计划 */
                        ) + _vm.$t("pc_biz_enroll_lbl_colon" /* : */)
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm.project.planName
                ? _c(
                    "yxt-tooltip",
                    {
                      attrs: {
                        content: _vm.project.planName,
                        placement: "top",
                        "open-filter": "",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "color-gray-10 ellipsis nowrap" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.project.planName) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _c("div", { staticClass: "color-gray-10" }, [_vm._v("--")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-row",
        { staticClass: "yxtbiz-project-audit__row", attrs: { gutter: 32 } },
        [
          _c(
            "yxt-col",
            { staticClass: "yxtbiz-project-audit__col", attrs: { span: 12 } },
            [
              _c(
                "div",
                { staticClass: "color-gray-7 yxtbiz-project-audit__label" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("pc_biz_training_lbl_classification" /* 分类 */) +
                        _vm.$t("pc_biz_enroll_lbl_colon" /* : */)
                    )
                  ),
                ]
              ),
              _vm.project.catalogName
                ? _c(
                    "yxt-tooltip",
                    {
                      attrs: {
                        content: _vm.project.catalogName,
                        placement: "top",
                        "open-filter": "",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "color-gray-10 ellipsis nowrap" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.project.catalogName) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _c("div", { staticClass: "color-gray-10" }, [_vm._v("--")]),
            ],
            1
          ),
          _c(
            "yxt-col",
            { staticClass: "yxtbiz-project-audit__col", attrs: { span: 12 } },
            [
              _c("div", { staticClass: "color-gray-7" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("pc_biz_enroll_lbl_projecttime" /* 项目时间 */) +
                      _vm.$t("pc_biz_enroll_lbl_colon" /* : */)
                  )
                ),
              ]),
              _vm.project.timeType === 0
                ? _c("div", { staticClass: "color-gray-10" }, [
                    _vm._v(
                      _vm._s(
                        _vm.project.startTime
                          ? _vm.project.startTime.slice(0, 16) +
                              " ~ " +
                              _vm.project.endTime.slice(0, 16)
                          : "--"
                      )
                    ),
                  ])
                : _vm.project.timeType === 1
                ? _c("div", { staticClass: "color-gray-10" }, [
                    _vm._v(
                      _vm._s(_vm.project.cycle) +
                        _vm._s(_vm.$t("pc_biz_rule_unit_day" /* 天 */))
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "yxt-row",
        { staticClass: "yxtbiz-project-audit__row", attrs: { gutter: 32 } },
        [
          _c(
            "yxt-col",
            { staticClass: "yxtbiz-project-audit__col", attrs: { span: 12 } },
            [
              _c("div", { staticClass: "color-gray-7" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("pc_biz_project_creator" /* 项目创建人 */) +
                      _vm.$t("pc_biz_enroll_lbl_colon" /* : */)
                  )
                ),
              ]),
              _c("div", { staticClass: "color-gray-10" }, [
                _vm._v(_vm._s(_vm.project.createName)),
              ]),
            ]
          ),
          _c(
            "yxt-col",
            { staticClass: "yxtbiz-project-audit__col", attrs: { span: 12 } },
            [
              _c(
                "div",
                { staticClass: "color-gray-7 yxtbiz-project-audit__label" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("pc_biz_project_owner" /* 项目负责人 */) +
                        _vm.$t("pc_biz_enroll_lbl_colon" /* : */)
                    )
                  ),
                ]
              ),
              _c(
                "yxt-tooltip",
                { attrs: { placement: "top", "open-filter": "" } },
                [
                  _c(
                    "div",
                    { attrs: { slot: "content" }, slot: "content" },
                    [
                      _c("yxtbiz-user-name", {
                        attrs: {
                          name: (_vm.project.relatedUserName || []).join(";"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "color-gray-10 ellipsis nowrap" },
                    [
                      _c("yxtbiz-user-name", {
                        attrs: {
                          name: (_vm.project.relatedUserName || []).join(";"),
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-row",
        { staticClass: "yxtbiz-project-audit__row", attrs: { gutter: 32 } },
        [
          _c(
            "yxt-col",
            { staticClass: "yxtbiz-project-audit__col", attrs: { span: 12 } },
            [
              _c(
                "div",
                { staticClass: "color-gray-7 yxtbiz-project-audit__label" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pc_biz_formal_learner_num" /* 学员总数（正式） */
                      ) + _vm.$t("pc_biz_enroll_lbl_colon" /* : */)
                    )
                  ),
                ]
              ),
              _c("div", { staticClass: "color-gray-10" }, [
                _vm._v(
                  _vm._s(
                    _vm.project.userCount !== 0 && !_vm.project.userCount
                      ? "--"
                      : _vm.project.userCount
                  )
                ),
              ]),
            ]
          ),
          _c(
            "yxt-col",
            { staticClass: "yxtbiz-project-audit__col", attrs: { span: 12 } },
            [
              _c("div", { staticClass: "color-gray-7" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "pc_o2o_lbl_total_budget_amount" /* 预算金额总和 */
                    ) + _vm.$t("pc_biz_enroll_lbl_colon" /* : */)
                  )
                ),
              ]),
              _c("div", { staticClass: "color-gray-10" }, [
                _vm._v(
                  _vm._s(_vm._f("numWithThousandth")(_vm.project.budgetSum))
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "yxt-row",
        { staticClass: "yxtbiz-project-audit__row", attrs: { gutter: 32 } },
        [
          _c(
            "yxt-col",
            { attrs: { span: 24 } },
            [
              _c(
                "yxt-button",
                { attrs: { type: "text" }, on: { click: _vm.goProjectDetail } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("pc_biz_view_project_detail" /* 查看项目详情 */)
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }